export default "__VITE_ASSET__C6Kk_fjk__"